export const apiBaseUrl = "https://api.geegz.fr"
